<template>
  <div v-if="pgLoading" class="loadingLogo">
    <img src="/assets/img/logo/charity-logo.png" alt="children's heart logo" />
  </div>
  <div v-else class="">
    <Banner :background="info.image ? info.image.url : ''" :title="!pgLoading ? $t('app.mongezProjects') : ''"
      :subtitle="!pgLoading ? $t('app.mongezProjects') : ''">
    </Banner>

    <section class="course-area course-area-02 pt-50 pb-50">
      <div class="container">
        <div class="project-cards-grid">
          <ProjectCard v-for="(row, idx) in rows" :key="idx" :row="row" />
        </div>

        <!-- Pagination -->
        <Pagination v-if="!pgLoading" :currentPage="paginate.currentPage" :itemsPerPage="paginate.itemsPerPage"
          :resultCount="paginate.resultCount" :nextPage="paginate.nextPage" :prevPage="paginate.prevPage"
          v-on:pageChange="handlePageChange">
        </Pagination>
        <!-- End Pagination -->
      </div>
    </section>
  </div>
</template>

<script>
import sendEvent from "@/helpers/sendEvent";
import { trackAddToCart } from "@/helpers/pixel";
export default {
  name: "List",
  components: {
    Banner: () => import("@/components/Banner.vue"),
    ProjectCard: () => import("@/components/ProjectCard.vue"),
    Pagination: () => import("@/components/Pagination.vue"),
  },
  data() {
    return {
      //
      auth: {
        access_token: "",
      },
      items: [],
      refs: "projects",

      locale: "ar",
      pgLoading: true,
      info: "",
      countries: [],
      categories: [],
      rows: [],
      search: "",

      country_id: "",
      category_id: "",
      category_slug: "",

      city_id: "",
      cityLoading: false,
      cities: [],

      paginate: {
        currentPage: 1,
        itemsPerPage: 24,
        resultCount: 0,
        nextPage: 2,
        prevPage: 0,
      },

      whatsAppNo: window.whatsAppNo,
      paymentStatus: 1,
    };
  },
  mounted() {
  },
  watch: {
    $route() {
      if (this.$route.params.slug) {
        this.category_slug = this.$route.params.slug;
      }
      if (this.$route.params.country_id) {
        this.country_id = this.$route.params.country_id;
      }
      this.fetchData();
    },
  },
  created() {
    //
    if (localStorage.getItem("access_token")) {
      this.auth.access_token = localStorage.getItem("access_token");
    }
    if (localStorage.getItem("locale")) {
      this.locale = localStorage.getItem("locale");
    }

    if (this.$route.params.slug) {
      this.category_slug = this.$route.params.slug;
    }
    if (this.$route.params.country_id) {
      this.country_id = this.$route.params.country_id;
    }

    this.fetchData();
    this.fetchPayment();
  },
  methods: {
    getTitleSeo() {
      let lang = this.$i18n.locale;
      let meta = this.info.meta;
      let data = meta
        ? lang == "ar"
          ? meta.ar.meta_title
          : meta.en.meta_title
        : "Projects";
      return data;
    },
    getDescSeo() {
      let lang = this.$i18n.locale;
      let meta = this.info.meta;

      let data = meta
        ? lang == "ar"
          ? meta.ar.meta_description
          : meta.en.meta_description
        : "meta_description";
      return data;
    },
    getKeywordsSeo() {
      let lang = this.$i18n.locale;
      let meta = this.info.meta;

      let data = meta
        ? lang == "ar"
          ? meta.ar.meta_keywords
          : meta.en.meta_keywords
        : "meta_keywords";
      return data;
    },

    fetchPayment() {
      const options = {
        url: window.baseURL + "/settings/26",
        method: "GET",
      };

      this.$axios(options)
        .then((res) => {
          this.paymentStatus = res.data.status;
        })
        .catch(() => {
          this.paymentStatus = 0;
        })
        .finally(() => { });
    },
    //
    fetchData(scrolTop = true) {
      if (scrolTop) {
        window.scrollTo(0, 0);
      }
      this.pgLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
        Authorization: `Bearer ` + this.auth.access_token,
      };
      const options = {
        url: window.baseURL + "/mongezProjects",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          country_id: this.country_id,
          city_id: this.city_id,
          search: this.$route.query.q,
          status: "active",
          paginate: this.paginate.itemsPerPage,
          page: this.paginate.currentPage,
          completeOrNew: 0,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.pgLoading = false;
          this.rows = res.data.rows;
          this.countries = res.data.countries;
          this.categories = res.data.categories;

          // info
          this.info = res.data.info;
          this.category_id = res.data.info.id;

          // paginate
          this.paginate.currentPage = res.data.paginate.current_page;
          this.paginate.resultCount = res.data.paginate.total;
          this.paginate.nextPage = res.data.paginate.next_page;
          this.paginate.prevPage = res.data.paginate.prev_page;
        })
        .catch(() => { })
        .finally(() => { });
    },

    onCountry: function () {
      this.fetchCities();
      this.city_id = "";
      this.fetchData(false);
    },
    onCities: function () {
      this.fetchData(false);
    },

    onCategory: function () {
      this.$router.push({
        name: "show-categories",
        params: { slug: this.category_slug },
      });
    },

    fetchCities() {
      this.cityLoading = true;
      this.axios.defaults.headers.common = {
        "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
      };
      const options = {
        url: window.baseURL + "/cities",
        method: "GET",
        data: {},
        params: {
          locale: this.locale,
          country_id: this.country_id,
        },
      };
      this.$axios(options)
        .then((res) => {
          this.cityLoading = false;
          this.cities = res.data.rows;
        })
        .catch(() => { })
        .finally(() => { });
    },

    handlePageChange(event) {
      this.paginate.currentPage = event.currentPage;
      this.fetchData();
    },

    addToCart(proid, donation = false) {
      // paymentStatus
      if (this.paymentStatus == 0) {
        iziToast.warning({
          icon: "ti-alert",
          title: "",
          message: this.$t("app.payment_status_error"),
        });
        return false;
      }

      if (!this.auth.access_token) {
        this.$router.push({ name: "login" });
      } else if (donation) {
        iziToast.warning({
          icon: "ti-alert",
          title: "",
          message: this.$t("app.donate_before_msg"),
        });
      } else {
        this.showLoading(proid);
        this.axios.defaults.headers.common = {
          "X-Requested-With": "XMLHttpRequest", // security to prevent CSRF attacks
          Authorization: `Bearer ` + this.auth.access_token,
        };
        const options = {
          url: window.baseURL + "/carts",
          method: "POST",
          data: {
            model_id: proid,
            model_type: "projects",
          },
          params: {},
        };
        this.$axios(options)
          .then(() => {
            sendEvent("AddToCart");
            trackAddToCart({
              currency: "KWD",
              content_ids: [proid],
              content_type: "projects",
            });
            this.successLoading(proid);
            iziToast.success({
              icon: "ti-check",
              title: "",
              message: "this.$t('app.add_msg')",
            });
          })
          .catch((err) => {
            this.hideLoading(proid);
            if (err.response && err.response.status == 401) {
              this.removeLocalStorage();
              this.$router.push({ name: "login" });
            } else {
              iziToast.warning({
                icon: "ti-alert",
                title: "",
                message: err.response ? this.$t("app.add_fail") : "" + err,
              });
            }
          })
          .finally(() => { });
      }
    },

    removeLocalStorage() {
      localStorage.removeItem("access_token");
      localStorage.removeItem("user_image");
      localStorage.removeItem("first_name");
      localStorage.removeItem("last_name");
      localStorage.removeItem("user_id");
      localStorage.removeItem("email");
      localStorage.removeItem("id_number");
    },

    showLoading(proid) {
      let btn = document.querySelectorAll("a#btnDonate_" + proid);
      let app = btn[btn.length - 1];
      app.classList.add("hidden");

      let loading = document.querySelectorAll("a#btnLoading_" + proid);
      let app2 = loading[loading.length - 1];
      app2.classList.remove("hidden");
    },

    hideLoading(proid) {
      let btn = document.querySelectorAll("a#btnDonate_" + proid);
      let app = btn[btn.length - 1];
      app.classList.remove("hidden");

      let loading = document.querySelectorAll("a#btnLoading_" + proid);
      let app2 = loading[loading.length - 1];
      app2.classList.add("hidden");
    },

    successLoading(proid) {
      let btn = document.querySelectorAll("a#btnDonate_" + proid);
      let app = btn[btn.length - 1];
      app.classList.add("hidden");

      let loading = document.querySelectorAll("a#btnLoading_" + proid);
      let app2 = loading[loading.length - 1];
      app2.classList.add("hidden");

      let success = document.querySelectorAll("a#btnSuccess_" + proid);
      let app3 = success[success.length - 1];
      app3.classList.remove("hidden");
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>